import { FC } from 'react';
import { SetState } from 'src/types/generic';
import { CalendarYear } from './FiscalYearsTableGridToolbar';

interface CalendarYearModalProps {
  calendarYear: CalendarYear[];
  setCalendarYear: SetState<CalendarYear[]>;
}

const CalendarYearModal: FC<CalendarYearModalProps> = ({ calendarYear, setCalendarYear }) => {
  const handleYearClick = (dataItem: CalendarYear) => {
    setCalendarYear((prevState) =>
      [...prevState].map((item) =>
        item.yearCount === dataItem.yearCount
          ? { ...item, selected: true }
          : { ...item, selected: false }
      )
    );
  };

  return (
    <div>
      <p className="mb-2">Select the number of Fiscal years you want to create.</p>
      <p className="mb-2">
        All Fiscal years starts on Jan 1st and ends on Dec 31st and has 12 periods, one for each
        month.
      </p>

      <ul>
        {calendarYear.map((props) => (
          <li
            onClick={(e) => {
              handleYearClick(props);
            }}
            key={props.yearCount}
            className={`flex justify-between mb-2 p-2 border rounded ${
              props.selected ? 'border-[#0E80B4] bg-[#0E80B433]' : 'border-gray'
            }`}
          >
            <span>{props.yearCount} Year</span>
            <span>{props.years}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CalendarYearModal;
